/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliStudentForParentDto } from '../../models/amoxcalli-student-for-parent-dto';

export interface ApiStudentsIdForParentGet$Plain$Params {
  id: string;
}

export function apiStudentsIdForParentGet$Plain(http: HttpClient, rootUrl: string, params: ApiStudentsIdForParentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliStudentForParentDto>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsIdForParentGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliStudentForParentDto>;
    })
  );
}

apiStudentsIdForParentGet$Plain.PATH = '/api/students/{id}/for-parent';
